<div class="flex justify-between content-center">
  <h3
    mat-dialog-title
    data-test-id="ask-expert-followup-questions-dialog-title"
  >
    Ask follow-up questions
  </h3>
  <button mat-icon-button mat-dialog-close>
    <mat-icon data-test-id="ask-expert-followup-questions-dialog-close"
      >clear</mat-icon
    >
  </button>
</div>

<mat-dialog-content class="flex flex-col">
  <form class="flex flex-col gap-8" [formGroup]="submissionForm">
    <mat-form-field appearance="outline">
      <mat-label
        data-test-id="ask-expert-followup-questions-dialog-experts-label"
        >Which expert(s) would you like to ask follow-up questions
        of?</mat-label
      >
      <mat-select
        matInput
        formControlName="expertIds"
        multiple
        data-test-id="ask-expert-followup-questions-dialog-experts"
      >
        @for (expert of data.expertOptions; track expert.expertId) {
          <mat-option
            data-test-id="ask-expert-followup-questions-dialog-experts-option"
            [value]="expert.expertId"
            >{{ expert.expertName }}</mat-option
          >
        }
      </mat-select>
      <mat-error
        data-test-id="ask-expert-followup-questions-dialog-recipients-error"
      >
        At least one expert is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label
        data-test-id="ask-expert-followup-questions-dialog-question-label"
        >Question to expert(s)</mat-label
      >
      <textarea
        matInput
        formControlName="question"
        style="min-height: 200px; resize: none"
        placeholder="What questions would you like your selected experts to answer?"
        data-test-id="ask-expert-followup-questions-dialog-question"
      ></textarea>
      <mat-error
        data-test-id="ask-expert-followup-questions-dialog-question-error"
      >
        Question is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label
        data-test-id="ask-expert-followup-questions-dialog-duration-label"
      >
        How much time would you like each expert to take answering your
        questions?
      </mat-label>
      <mat-select
        matInput
        formControlName="priceId"
        data-test-id="ask-expert-followup-questions-dialog-duration"
      >
        @for (option of pricingOptions; track option.priceId) {
          <mat-option
            data-test-id="ask-expert-followup-questions-dialog-duration-option"
            [value]="option.priceId"
            >{{ option.label }}</mat-option
          >
        }
      </mat-select>
      <mat-error
        data-test-id="ask-expert-followup-questions-dialog-duration-error"
      >
        Estimated time required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label
        data-test-id="ask-expert-followup-questions-dialog-deadline-label"
      >
        When would you like to receive your answers by?
      </mat-label>
      <input
        matInput
        type="date"
        formControlName="deadline"
        data-test-id="ask-expert-followup-questions-dialog-deadline"
        [min]="minDate"
      />
      <mat-hint
        data-test-id="ask-expert-followup-questions-dialog-deadline-hint"
      >
        Please allow a minimum of one working day
      </mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    type="button"
    mat-stroked-button
    mat-dialog-close
    color="primary"
    data-test-id="ask-expert-followup-questions-dialog-cancel"
    class="flex-1 primaryColor-border"
  >
    Close window
  </button>
  <button
    type="submit"
    mat-flat-button
    class="flex-1"
    color="primary"
    data-test-id="ask-expert-followup-questions-dialog-confirm"
    (click)="submit()"
  >
    Confirm
  </button>
</mat-dialog-actions>
